<template>
  <div>
    <!-- begin breadcrumb -->
    <breadcrumb activeName="文章管理" :breadcrumbItem="[{ to: '/artical/list', name: '文章列表' }]"></breadcrumb>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      文章管理
      <small>文章信息管理...</small>
    </h1>
    <!-- end page-header -->
    <panel title="商品列表" :noButton="true">
      <div slot="heading-btn">
        <button class="btn btn-theme btn-sm" type="button" @click="fn_add">
          <i class="fa fa-plus"></i> 添加文章
        </button>
      </div>
      <listFilter ref="listFilter" :categoryTree="categoryTree" @on-search="fn_search"></listFilter>
      <Table size="small" :columns="columns" :data="data">
        <template slot-scope="{ row }" slot="category">
          <span v-if="row.category">{{ row.category.name }}</span>
        </template>
        <template slot-scope="{ row }" slot="is_show">
          <span v-if="row.is_show == 1">
            <Icon type="md-checkmark" />
          </span>
        </template>
        <template slot-scope="{ row }" slot="is_new">
          <span v-if="row.is_new == 1">
            <Icon type="md-checkmark" />
          </span>
        </template>
        <template slot-scope="{ row }" slot="is_hot">
          <span v-if="row.is_hot == 1">
            <Icon type="md-checkmark" />
          </span>
        </template>
        <template slot="action" slot-scope="{ row, index }">
          <button class="btn btn-theme btn-sm m-l-5" type="button" @click="fn_edit(row, index)">
            <i class="fa fa-edit"></i>
          </button>

          <Poptip
            class="m-l-5"
            transfer
            confirm
            title="确认要删除这篇文章吗?"
            @on-ok="fn_remove(row, index)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button class="btn btn-danger btn-sm" type="button" ghost>
              <i class="fa fa-times"></i>
            </button>
          </Poptip>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="currentPage"
        :page-size="pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
  </div>
</template>
<script>
import breadcrumb from "@/components/breadcrumb";
import {
  getArticalList,
  getCategoryTreeSelect,
  removeArticalData
} from "@/api/artical";
import listFilter from "./list_filter";
export default {
  components: {
    breadcrumb,
    listFilter
  },
  data() {
    return {
      columns: [
        {
          title: "#ID",
          key: "id",
          width: 50
        },
        {
          title: "文章目录",
          slot: "category",
          width: 150
        },
        {
          title: "标题",
          key: "title",
          minWidth: 200
        },
        {
          title: "关键字",
          key: "keywords",
          minWidth: 200
        },
        {
          title: "主要描述",
          key: "description",
          minWidth: 300
        },
        {
          title: "显示",
          slot: "is_show",
          width: 70
        },
        {
          title: "排序",
          key: "sortval",
          width: 70
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "left"
        }
      ],
      data: [],
      totalRows: 0,
      currentPage: 1,
      pageNum: 15,

      action: "new",
      categoryTree: []
    };
  },
  mounted() {
    getCategoryTreeSelect()
      .then(res => {
        this.categoryTree = [
          {
            id: 0,
            label: "目录顶级节点",
            children: res.data
          }
        ];
      })
      .catch(error => {
        this.$Message.error(error);
      });
    let filterCond = this.$refs.listFilter.formData;
    this.fn_search(filterCond);
  },
  methods: {
    fn_search() {
      let filterCond = this.$refs.listFilter.formData;
      filterCond.page = 1;
      this.fn_load(filterCond);
    },
    fn_load(filterCond) {
      getArticalList(filterCond)
        .then(res => {
          this.data = res.data.data;
          this.totalRows = res.data.total;
        })
        .catch(error => {
          this.$Message.error("错误" + error);
        });
    },
    fn_add() {
      this.action = "new";
      const route = {
        name: "artical_edit",
        params: {
          id: 0
        }
      };
      this.$router.push(route);
    },
    fn_edit(row, index) {
      this.action = "edit";
      const route = {
        name: "artical_edit",
        params: {
          id: row.id
        }
      };
      this.$router.push(route);
    },
    fn_remove(row, index) {
      removeArticalData(row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
            this.data.splice(index, 1);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_switchPage(page) {
      let filterCond = this.$refs.listFilter.formData;
      filterCond.page = page;

      this.fn_load(filterCond);
    }
  }
};
</script>
